<!-- 创建时间2023/06/13 15:52:41 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：课件信息 -->
<template>
  <yxt-form
    class="yxtbiz-kng-operator__form pl15"
    :class="error ? 'yxtbiz-kng-operator__form--error' : ''"
    :model="info"
    ref="form"
    label-position="top"
    size="small"
    label-width="150px"
  >
    <div id="info_1" class="yxtbiz-kng-operator__form-title">{{ $t('pc_kng_kngcourse_menu_basic'/** 基本信息 */) }}</div>
    <yxt-form-item
      v-if="info.serverGroupId"
      :label="$t('pc_kng_courseware_lbl_mediaservergroup'/**媒体服务器组 */)"
      label-width="150px"
      prop="serverGroupId"
    >
      {{ info.serverGroupName }}
    </yxt-form-item>

    <yxt-form-item
      v-if="getItemShow('link')"
      :label="$t('pc_kng_courseware_lbl_newlink'/**课件链接 */)"
      prop="indexPath"
      :rules="getItemRules('link')"
    >
      <yxt-input
        v-model="info.indexPath"
        maxlength="500"
        show-word-limit
        autofocus
        clearable
        :disabled="getItemDisabled('link')"
        :placeholder="$t('pc_kng_upload_tip_newlink_input'/**请输入课件网址，建议使用https格式的网址，http网址不支持在iPhone手机中播放 */)"
      ></yxt-input>
    </yxt-form-item>

    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.NAME)"
      :label="$t('pc_biz_kng_lbl_name'/**名称 */)"
      prop="title"
      :rules="getItemRules(COURSE_ATTRIBUTE.NAME)"
    >
      <yxt-input
        v-model="info.title"
        show-word-limit
        maxlength="200"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.NAME)"
      ></yxt-input>
    </yxt-form-item>

    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.CATAlOG)"
      :label="$t('pc_kng_kngcourse_lbl_catlog'/**分类 */)"
      prop="catalogId"
      :rules="getItemRules(COURSE_ATTRIBUTE.CATAlOG)"
    >
      <form-catalog :id.sync="info.catalogId" :name.sync="info.catalogName" :disabled="getItemDisabled(COURSE_ATTRIBUTE.CATAlOG)" :info="info"/>
    </yxt-form-item>

    <yxt-form-item v-if="getItemShow('point')">
      <div slot="label" class="yxtbiz-flex-center yxtbiz-kng-operator__form-points">
        {{ $t('pc_kng_mark_lbl_key'/** 关键点 */) }}
        <yxt-popover
          trigger="hover"
          placement="right-start"
          :offset="-10"
          max-width="317">
          <span>
            <div class="yxt-weight-5">{{ $t('pc_biz_lbl_pointsintro'/** 关键点介绍 */) }}</div>
            <div class="color-gray-9 mt5">{{ $t('pc_biz_lbl_pointsdesc'/** 根据内容提炼主题，设置关键点，方便学员学习。 */) }}</div>
            <yxt-image class="mt12" :src="pointImageUrl" fit="cover"></yxt-image>
          </span>
          <yxt-svg
            slot="reference"
            class="color-gray-6 v-mid ml4 hover-primary-6"
            width="16px"
            height="16px"
            icon-class="icons/question-cirlce-o"
          />
        </yxt-popover>
      </div>
      <form-point :points.sync="info.keyPoints" :kng-id="info.id" :fileId="info.fileId" :showAiPoints="!isHideAISubtitles && !info.serverGroupId && !info.distributeSourceType" :disabled="getItemDisabled('point')"/>
    </yxt-form-item>
    <yxt-form-item v-if="getItemShow('coverUrl')" :label="$t('pc_biz_lbl_cover'/**封面 */)">
      <form-cover :type.sync="info.photoType" :coverUrl.sync="info.coverUrl" />
    </yxt-form-item>

    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.TIME)"
      :label="$t('pc_biz_kng_lbl_standardduration'/** 标准时长 */)"
      prop="studyHours"
      :rules="getItemRules(COURSE_ATTRIBUTE.TIME)"
    >
      <form-time
        v-model="info.studyHours"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.TIME)"
        @change="changeStudyHours"
      />
    </yxt-form-item>

    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.SCORE)"
      :label="$t('pc_biz_kng_lbl_studyScore'/**学分 */)"
      prop="studyScore"
      :rules="getItemRules(COURSE_ATTRIBUTE.SCORE)"
    >
      <yxtbiz-language-slot lang-key="pc_biz_kng_msg_studyscore">
        <span v-if="info.type === KNG_TYPE.COURSE" slot="0">{{ info.studyScore }}</span>
        <yxt-tooltip
            v-else
            :disabled="canEditCredits"
            slot="0"
            :content="$t('pc_biz_lbl_noeditauth'/** 无编辑权限 */)"
          >
          <yxt-input-number
            class="mr4"
            v-model="info.studyScore"
            :precision="2"
            :step="1"
            :max="9999.99"
            :min="0"
            :disabled="getItemDisabled(COURSE_ATTRIBUTE.SCORE) || !canEditCredits"
          ></yxt-input-number>
        </yxt-tooltip>
      </yxtbiz-language-slot>
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.UNIQUE_CODE)"
      :label="$t('kng_lbl_unique_code'/** 平台课程编号*/)"
      prop="uniqueCode"
      :rules="getItemRules(COURSE_ATTRIBUTE.UNIQUE_CODE)"
    >
      <yxt-input disabled v-model="info.uniqueCode" />
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.CUSTOM_CODE)"
      :label="$t('kng_lbl_custom_code'/**自定义课程编号 */)"
      prop="customCOde"
      :rules="getItemRules(COURSE_ATTRIBUTE.CUSTOM_CODE)"
    >
      <form-custom-code></form-custom-code>
    </yxt-form-item>
    <yxt-form-item
      v-if="info.distributeSourceType"
      :label="$t('pc_biz_kng_lbl_zoCode'/**商城课编号 */)"
      prop="zoCode"
    >
      <yxt-input disabled :value="info.zoCode || '--'" />
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.VALID_DATE)"
      :label="$t('pc_biz_kng_coursevalidtime'/** 有效期 */)"
      prop="expiredTime"
      :rules="getItemRules(COURSE_ATTRIBUTE.VALID_DATE)"
    >
      <div>
        <yxt-date-picker
          v-model="info.expiredTime"
          type="date"
          value-format="yyyy-MM-dd"
          :disabled="getItemDisabled(COURSE_ATTRIBUTE.VALID_DATE)"
          :placeholder="$t('pc_biz_rule_select_date'/** 选择日期 */)"/>
        <span class="ml8 color-gray-6">{{$t('pc_kng_upload_lbl_expire_tip'/** 超过有效期后，学员无法学习该课程 */)}}</span>
      </div>
      <div class="yxtbiz-flex-center mt12" v-if="!getItemDisabled(COURSE_ATTRIBUTE.VALID_DATE)">
        <yxt-checkbox v-model="info.expireNotice" :true-label="1" :false-label="0"/>
        <yxtbiz-language-slot className="ml8" langKey="pc_kng_upload_lbl_expire_notice">
          <yxt-input-number class="w104 ml8 mr8" v-model="info.expireDay" slot="0" :min="0" :precision="0" :disabled="!info.expireNotice"/>
          <yxt-input-number class="w104 ml8 mr8" v-model="info.expireHours" slot="1" :min="0" :max="23" :precision="0" :step="1" :disabled="!info.expireNotice"/>
        </yxtbiz-language-slot>
      </div>
    </yxt-form-item>
    <yxt-form-item
      v-if="isEdit && info.type === KNG_TYPE.HTML && !info.specialMode"
      prop="indexPath"
      :label="$t('pc_kng_kngcourse_lbl_setindex'/** 设置首页 */)"
      :rules="getItemRules('indexPath')"
    >
      <form-index
        v-model="info.indexPath"
        :content="info.courseChapterContent"
        :disabled="getItemDisabled('indexPath')"
      />
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.PRICE)"
      :label="$t('pc_biz_common_lbl_price'/** 价格 */)"
      prop="price"
      :rules="getItemRules(COURSE_ATTRIBUTE.PRICE)"
    >
      <yxtbiz-language-slot lang-key="pc_biz_lbl_credits">
        <yxt-input-number
          class="mr4"
          slot="0"
          v-model="info.price"
          :precision="0"
          :step="1"
          :max="9999"
          :min="0"
          :disabled="getItemDisabled(COURSE_ATTRIBUTE.PRICE)"
        ></yxt-input-number>
        <span class="color-gray-6" slot="1">
          {{$t('pc_kng_upload_msg_point'/**（设置积分后，学员需要使用相应的积分兑换后方可学习） */)}}
        </span>
      </yxtbiz-language-slot>
    </yxt-form-item>
    <yxt-form-item v-if="getItemShow('completeStandard')" :label="$t('pc_biz_kng_lbl_class_completion_standard'/**完课标准 */)">
      <form-complete-standard
        ref="standard"
        :contentCompleteStandard.sync="info.contentCompleteStandard"
        :timeCompleteStandard.sync="info.timeCompleteStandard"
        :disabled="getItemDisabled('completeStandard')"
      />
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.CONTENT_TAG)"
      :label="$t('pc_biz_kng_lbl_contentlabel'/**内容标签 */)"
      prop="contentTags"
      :rules="getItemRules(COURSE_ATTRIBUTE.CONTENT_TAG)"
    >
      <form-content-tag
        v-model="info.contentTags"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.CONTENT_TAG)"
        @change="$refs.form.validateField('contentTags')"
      />
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.SKILL_TAG)"
      prop="skillTags"
      :label="$t('pc_biz_kng_lbl_abilitylabel'/**能力标签 */)"
      :rules="getItemRules(COURSE_ATTRIBUTE.SKILL_TAG)"
    >
      <form-skill-tag
        v-model="info.skillTags"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.SKILL_TAG)"
        @change="$refs.form.validateField('skillTags')"
      />
    </yxt-form-item>
    <yxt-form-item v-if="getItemShow('displayMode')" :label="$t('pc_kng_kng_lbl_displaymode'/**展示模式 */)">
      <form-display-mode
        v-model="info.displayMode"
        :size.sync="info.fontSize"
        :show-size="getItemShow('fontSize')"
        :show-size-limit="getItemShow('fontSizeLimit')"
        :disabled="getItemDisabled('displayMode')"
      />
    </yxt-form-item>
    <yxt-form-item v-if="getItemShow('dataType')" :label="$t('pc_biz_kng_lbl_datatype'/**资料类型 */)">
      <yxt-select class="width-percent-100-i" v-model="info.studyMaterialType" clearable :disabled="getItemDisabled('dataType')">
        <yxt-option :value="1" :label="$t('kng_tag_lbl_display_type1')"/>
        <yxt-option :value="2" :label="$t('kng_tag_lbl_display_type2')"/>
        <yxt-option :value="3" :label="$t('kng_tag_lbl_display_type3')"/>
      </yxt-select>
      <div class="color-gray-6 lh24 mt8">
        {{ $t('kng_tag_lbl_display_type_desc'/** 课件/课程加入学习项目后会作为学习资料，有单独的入口展示 */) }}
        <yxt-button type="text" @click="view(0)">{{ $t('pc_kng_doc_support_html_lbl_demo') }}</yxt-button>
      </div>
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.DESCRIBE)"
      prop="description"
      :label="$t('pc_biz_kng_detail_lbl_introduction'/**简介 */)"
      :rules="getItemRules(COURSE_ATTRIBUTE.DESCRIBE)">
      <form-desc :htmlDesc.sync="info.description" :disabled="getItemDisabled('COURSE_ATTRIBUTE.DESCRIBE')"/>
    </yxt-form-item>
    <yxt-form-item v-if="getItemShow(COURSE_ATTRIBUTE.ATTACHMENT)" :label="$t('pc_biz_kng_lbl_attachment'/**附件 */)">
      <form-attachment
        ref="attachmentForm"
        :list.sync="info.kngAttachSimpleBeans"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.ATTACHMENT)"
      />
    </yxt-form-item>
    <!-- 自定义属性 -->
    <yxt-form-item
      v-for="item in baseAttrs"
      :label="item.attrName"
      :prop="item.attrId"
      :key="item.attrId"
      :rules="getItemRules(COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE, item)"
    >
      <form-base-custom :attr="item" :info="info" :disabled="getItemDisabled(COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE)"/>
    </yxt-form-item>
    <!-- 供应商 -->
    <yxt-form-item
      v-if="getItemShow('supplier')"
      :label="$t('pc_kng_kngcourse_lbl_supplier')"
    >
      <yxtbiz-supplier-select width="100%" :selectData="info.supplierId ? {supplierCreditCode: info.supplierId,supplierName: info.supplierName } : {}" @getSelected="didSelectSupplier"/>
    </yxt-form-item>
    <div id="info_2" class="yxtbiz-kng-operator__form-title mt32">
      {{ $t('pc_biz_kng_lbl_reletedinfo'/**相关方信息 */) }}
    </div>
    <!-- 贡献者 -->
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.CONTRIBUTOR)"
      :label="getAttrConfig(COURSE_ATTRIBUTE.CONTRIBUTOR).attrName"
      prop="contributorsUser"
      :rules="getItemRules(COURSE_ATTRIBUTE.CONTRIBUTOR)"
    >
      <form-related
        :name.sync="info.contributorsName"
        :id.sync="info.contributorsUser"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.CONTRIBUTOR)"
      />
      <yxt-checkbox v-if="config.openReward" v-model="info.rewardFlag" :true-label="1" :false-label="0" :disabled="getItemDisabled(COURSE_ATTRIBUTE.CONTRIBUTOR)">
        {{ $t('pc_kng_upload_lbl_allow_reward'/** 允许学员打赏 */) }}
      </yxt-checkbox>
    </yxt-form-item>
    <!-- 作者 -->
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.AUTHOR)"
      :label="getAttrConfig(COURSE_ATTRIBUTE.AUTHOR).attrName"
      prop="author"
      :rules="getItemRules(COURSE_ATTRIBUTE.AUTHOR)"
    >
      <form-related
        :name.sync="info.author"
        :id.sync="info.authorId"
        :attrId="getAttrConfig(COURSE_ATTRIBUTE.AUTHOR).id"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.AUTHOR)"
      />
      <yxt-checkbox
        v-model="info.originality"
        :true-label="1"
        :false-label="0"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.AUTHOR)"
        @change="changeOriginal"
        >{{ $t('pc_biz_kng_lbl_originaltag'/**原创 */) }}
      </yxt-checkbox>
    </yxt-form-item>
    <!-- 主讲 -->
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.LECTURER)"
      :label="getAttrConfig(COURSE_ATTRIBUTE.LECTURER).attrName"
      prop="lecturesName"
      :rules="getItemRules(COURSE_ATTRIBUTE.LECTURER)"
    >
      <form-related
        :name.sync="info.lecturesName"
        :id.sync="info.lecturesId"
        :attrId="getAttrConfig(COURSE_ATTRIBUTE.LECTURER).id"
        dataPermissionCode="Courselecturer_extent"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.LECTURER)"
      />
    </yxt-form-item>
    <!-- 辅讲 -->
    <yxt-form-item
      v-if="getItemShow(COURSE_ATTRIBUTE.ASSISTANT_LECTURER)"
      :label="getAttrConfig(COURSE_ATTRIBUTE.ASSISTANT_LECTURER).attrName"
      prop="counseLorteacherNames"
      :rules="getItemRules(COURSE_ATTRIBUTE.ASSISTANT_LECTURER)"
    >
      <form-related
        :name.sync="info.counseLorteacherNames"
        :id.sync="info.counseLorteacherIds"
        :attrId="getAttrConfig(COURSE_ATTRIBUTE.ASSISTANT_LECTURER).id"
        dataPermissionCode="CourseAssistantlecturer_extent"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.LECTURER)"
      />
    </yxt-form-item>
    <yxt-form-item
      v-for="item in relatedAttrs"
      :label="item.attrName"
      :key="item.attrId"
      :prop="item.attrId"
      :rules="getItemRules(COURSE_ATTRIBUTE.CUSTOM_RELATED, item)"
    >
      <form-related
        isCustom
        :name.sync="item.userName"
        :id.sync="item.value"
        :attrId="item.attrId"
        :disabled="getItemDisabled(COURSE_ATTRIBUTE.CUSTOM_RELATED)"
      />
    </yxt-form-item>
    <!-- 自定义属性 -->

    <div id="info_3" class="yxtbiz-kng-operator__form-title mt32">{{ $t('pc_biz_kng_lbl_authsetting'/**权限设置 */) }}</div>
    <yxt-form-item :label="$t('pc_biz_kng_lbl_ishide'/**是否隐藏 */)">
      <yxt-checkbox v-model="info.visiable" :true-label="0" :false-label="1" :disabled="getItemDisabled('visiable')">
        {{ $t('pc_kng_upload_msg_auth_text1'/**设为隐藏状态（仅在课程或项目中使用） */) }}
      </yxt-checkbox>
    </yxt-form-item>
    <yxt-form-item :label="$t('pc_biz_kng_lbl_shareauth'/** 分享权限 */)">
      <yxt-checkbox v-model="info.shareEnabled" :true-label="1" :false-label="0" :disabled="getItemDisabled('share')">
        {{ $t('pc_biz_kng_lbl_allowshare'/**允许Ta人分享 */) }}
      </yxt-checkbox>
    </yxt-form-item>
    <yxt-form-item v-if="getItemShow('appEnabled')" :label="$t('kng_biz_lbl_mobile_view'/** 手机观看 */)">
      <yxt-checkbox v-model="info.appEnabled" :true-label="1" :false-label="0" :disabled="getItemDisabled('appEnabled')">
        {{ $t('kng_biz_lbl_mobile_view_tip1'/** 支持手机观看（课程需要适配移动端，否则会导致学员使用手机学习时出现异常） */) }}
      </yxt-checkbox>
    </yxt-form-item>
    <yxt-form-item
      class="error-ml24"
      :label="$t('pc_biz_kng_lbl_viewauth'/**浏览权限 */)"
      prop="permissionType"
      :rules="getItemRules('browser')"
    >
      <form-browse-auth
        v-model="info.permissionType"
        :permissions.sync="info.browsePermissions"
        :isCourse="info.type === KNG_TYPE.COURSE"
        :disabled="getItemDisabled('browser')"
      />
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow('download')"
      class="error-ml24"
      :label="$t('pc_biz_kng_lbl_pcdownauth'/**下载权限 */)"
      prop="downEnabled"
      :rules="getItemRules('download')"
    >
      <form-download-auth
        v-model="info.downEnabled"
        :allowDownload.sync="info.allowDown"
        :permissions.sync="info.downloadPermissions"
        :disabled="getItemDisabled('download')"
      />
    </yxt-form-item>
    <yxt-form-item
      :label="$t('pc_kng_upload_label_down_filetype_title'/**下载文件 */)"
      v-if="getItemShow('download_source')"
    >
      <form-download-source v-model="info.downloadType" :batchSetting="batchSetting" :disabled="getItemDisabled('download_source')" />
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow('appCache')"
      :label="$t('pc_biz_kng_lbl_appcacheauth'/**App缓存课件权限 */)"
      class="error-ml24"
      prop="appDownEnabled"
      :rules="getItemRules('appCache')"
    >
      <form-app-cache-auth
        v-model="info.appDownEnabled"
        :allowDownload.sync="info.allowAppDown"
        :permissions.sync="info.appDownloadPermissions"
        :disabled="getItemDisabled('appCache')"
      />
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow('visitor')"
      class="error-ml24"
      :label="$t('pc_biz_kng_lbl_visitorstudy'/**游客访问 */)"
      prop="visitorConfDTO"
      :rules="getItemRules('visitor')"
    >
      <form-visitor :config.sync="info.visitorConfDTO" :disabled="getItemDisabled('visitor')"/>
    </yxt-form-item>

    <div id="info_4" class="yxtbiz-kng-operator__form-title mt32">{{ $t('pc_biz_kng_lbl_funsetting'/**功能设置 */) }}</div>
    <yxt-form-item v-if="getItemShow('autoUpgrade')" :label="$t('pc_kng_upload_lbl_newweike_autoupdate'/**自动更新 */)">
      <yxt-checkbox v-model="info.autoUpgrade" :true-label="1" :false-label="0" :disabled="getItemDisabled('autoUpgrade')">
        {{ $t('pc_kng_upload_lbl_newweike_autoupdate_text1'/**开启课件自动更新 */) }}
      </yxt-checkbox>
      <yxt-tooltip
        max-width="400"
        effect="dark"
        placement="bottom"
        :content="$t('pc_kng_upload_lbl_newweike_autoupdate_text1_tip' /* 开启后，微课更新时课件内容会自动更新到新版 */)"
      >
        <yxt-svg
          class="hand v-mid color-gray-6"
          width="16px"
          height="16px"
          icon-class="icons/question-cirlce-o"
        />
      </yxt-tooltip>
    </yxt-form-item>
    <yxt-form-item :label="$t('pc_biz_kng_lbl_completecomment'/**完课评论 */)">
      <yxt-checkbox
        v-model="info.enableStudyedAlert"
        :true-label="1"
        :false-label="0"
        :disabled="getItemDisabled('completeComment')"
        >{{ $t('pc_biz_kng_lbl_opencompletecomment'/** 开启完课评论弹窗 */) }}
      </yxt-checkbox>
    </yxt-form-item>
    <yxt-form-item v-if="getItemShow('bbs')" :label="$t('pc_biz_kng_bbscommunity'/**讨论区 */)">
      <yxt-checkbox v-model="info.enableBbs" :true-label="1" :false-label="0" :disabled="getItemDisabled('bbs')"
        >{{ $t('pc_biz_kng_lbl_openbbs'/** 开启讨论区 */) }}
      </yxt-checkbox>
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow('note')"
      :label="$t('pc_biz_kng_lbl_note'/**笔记区 */)"
      :label-tooltip="$t('pc_kng_courseware_tip_noteArea')"
    >
      <yxt-checkbox v-model="info.enableNote" :true-label="1" :false-label="0" :disabled="getItemDisabled('note')"
        >{{ $t('pc_biz_kng_lbl_openbote'/** 开启公开笔记区 */) }}
      </yxt-checkbox>
    </yxt-form-item>
    <yxt-form-item v-if="getItemShow('watermark')" :label="$t('pc_biz_kng_lbl_watercontrol'/**水印控制 */)">
      <yxt-radio-group direction="row" v-model="info.watermarkFlag" :disabled="getItemDisabled('watermark')">
        <yxt-radio :label="0">
          {{ $t('pc_kng_watermark_control_follow'/**跟随平台设置（我的企业-安全中心-数据安全-水印控制） */) }}
        </yxt-radio>
        <yxt-radio :label="1">{{ $t('pc_kng_watermark_control_close'/**不开启水印 */) }}</yxt-radio>
      </yxt-radio-group>
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow('multiShow')"
      :label="$t('pc_biz_kng_lbl_speedplay'/**倍速播放 */)"
      :label-tooltip="info.type === KNG_TYPE.COURSE ? $t('pc_kng_lbl_study_rate_tips') : ''"
    >
      <div v-if="multiConfig.multipleMode === 1">
        {{ $t('pc_kng_lbl_Speed_tip1'/**已开启倍速播放（学员可以切换1.25/1.5/1.75/2倍速播放） */) }}
      </div>
      <yxt-checkbox
        v-else
        v-model="info.enableMultipleSwitch"
        :true-label="1"
        :false-label="0"
        :disabled="getItemDisabled('multiShow')"
        >{{ $t('pc_kng_lbl_openSpeed'/** 开启倍速播放（开启后，学员可以切换1.25/1.5/1.75/2倍速播放）*/) }}
      </yxt-checkbox>
    </yxt-form-item>
    <yxt-form-item
      v-if="getItemShow('multiShow') && (info.enableMultipleSwitch || multiConfig.multipleMode === 1)"
      :label="$t('pc_kng_lbl_hours_calc'/**学时计算 */)"
    >
      <!-- 倍速播放时学习时长不会倍速计算（举例：学员2倍速学习5分钟，学习时长算5分钟） -->
      <div v-if="multiConfig.multipleMode === 1">
        {{
          multiConfig.multipleStudy === 1
            ? $t('pc_kng_lbl_Speed_tip3'/**倍速播放时学习时长也倍速计算（举例：学员2倍速学习5分钟，学习时长算10分钟） */)
            : $t('pc_kng_lbl_Speed_tip4'/**倍速播放时学习时长不会倍速计算（举例：学员2倍速学习5分钟，学习时长算5分钟） */)
        }}
      </div>
      <yxt-checkbox
        v-else
        v-model="info.enableMultiple"
        :true-label="1"
        :false-label="0"
        :disabled="getItemDisabled('multiShow')"
        >{{ $t('pc_kng_lbl_multipleStudy3'/** 倍速播放时学习时长也倍速计算（举例：学员2倍速学习5分钟，学习时长计算10分钟） */) }}
      </yxt-checkbox>
    </yxt-form-item>

    <yxt-form-item
      v-if="getItemShow('drag')"
      :label="$t('pc_biz_kng_lbl_dragstudy'/**拖拽学习 */)"
      :label-tooltip="
        info.type === KNG_TYPE.COURSE ? $t('pc_kng_lbl_study_tips') : ''
      "
    >
      <yxt-checkbox v-model="info.enableDrag" :true-label="1" :false-label="0" :disabled="getItemDisabled('drag')">
        {{ $t('pc_biz_kng_lbl_opendragstudy'/** 支持拖拽学习 */) }}
        <span v-if="!info.enableDrag" class="color-gray-6">{{ $t('pc_kng_lbl_dragStudy_tips'/**（仅限制未完课的学员拖拽） */) }}</span>
      </yxt-checkbox>
    </yxt-form-item>
    <yxt-form-item v-if="getItemShow('face')" :label="$t('pc_biz_lbl_appface'/**人脸识别（仅APP支持） */)">
      <form-face
        ref="faceForm"
        v-if="faceConfig.useScope === 0"
        :config.sync="faceConfig"
        disabled
      />
      <form-face
        ref="faceForm"
        v-else
        :disabled="getItemDisabled('face')"
        :config.sync="info.faceRecognitionConfig"
      />
    </yxt-form-item>
    <yxt-form-item v-if="getItemShow('AI')" :label="$t('pc_kng_lbl_ai_subtitles'/**AI字幕 */)" prop="subtitlesFlag" :rules="getItemRules('AI')">
      <yxt-tooltip :disabled="!!info.subtitlesStatus || config.canUseAI" :content="$t('pc_kng_lbl_ai_account_balance'/**账户余额不足，充值后才能使用 */)">
        <yxt-checkbox v-model="info.subtitlesFlag" :true-label="1" :false-label="0" :disabled="getItemDisabled('AI')">
          {{ $t('pc_kng_lbl_ai_subtitles_open'/** 开启AI字幕（开启后，该课件会生成字幕文稿，如您的音视频中自带字幕，请关闭该功能，避免字幕冲突） */) }}
        </yxt-checkbox>
      </yxt-tooltip>
      <yxt-checkbox v-if="info.subtitlesFlag" v-model="info.syncMark" :true-label="1" :false-label="0" :disabled="getItemDisabled('AI')">
        {{ $t('pc_kng_lbl_ai_sync_mark'/** 同步生成关键点标记（根据内容自动提炼主题，生成关键点） */) }}<yxt-button type="text" @click="view(1)">{{ $t('pc_kng_doc_support_html_lbl_demo'/** 查看示例 */) }}</yxt-button>
      </yxt-checkbox>

    </yxt-form-item>
    <yxtbiz-image-viewer
      v-if="url"
      ref="viewer"
      no-list
      :showNavbar="false"
      :showToolbar="false"
      :data="[{ url }]"
    />
  </yxt-form>
</template>

<script>
import formCatalog from './form-catalog.vue';
import formCover from './form-cover.vue';
import formTime from './form-time.vue';
import formIndex from './form-index.vue';
import formCompleteStandard from './form-complete-standard.vue';
import formContentTag from './form-content-tag.vue';
import formSkillTag from './form-skill-tag.vue';
import formDisplayMode from './form-display-mode.vue';
import formDesc from './form-desc.vue';
import formAttachment from './form-attachment.vue';
import formRelated from './form-related.vue';
import formBrowseAuth from './form-browse-auth.vue';
import formDownloadAuth from './form-download-auth.vue';
import formDownloadSource from './form-download-source.vue';
import formAppCacheAuth from './form-app-cache-auth.vue';
import FormVisitor from './form-visitor.vue';
import FormFace from './form-face.vue';
import FormBaseCustom from './form-base-custom.vue';
import FormPoint from './form-point.vue';
import FormCustomCode from './form-custom-code.vue';
import { COURSE_ATTRIBUTE } from '../../../enum';
import {
  KNG_FILE_TYPE,
  KNG_TYPE
} from 'yxt-biz-pc/packages/select-kng/src/const';
import { checkTimeOutFnc } from 'yxt-biz-pc/packages/common-util/getFactor';
import { getScoreWithConfig, isZhOrHa } from 'yxt-biz-pc/packages/kng-operator/utils';
export default {
  components: {
    formCatalog,
    formCover,
    formTime,
    formIndex,
    formCompleteStandard,
    formContentTag,
    formSkillTag,
    formDisplayMode,
    formDesc,
    formAttachment,
    formRelated,
    formBrowseAuth,
    formDownloadAuth,
    formDownloadSource,
    formAppCacheAuth,
    FormVisitor,
    FormFace,
    FormBaseCustom,
    FormPoint,
    FormCustomCode
  },
  name: 'kng-form',
  provide() {
    return {
      getInfo: () => this.info
    };
  },
  inject: [
    'getAttrConfigs',
    'getIsEdit',
    'getConfig',
    'getMultiConfig',
    'getFaceConfig',
    'getScoreConfig',
    'getUseInBuyCourse',
    'getPermissionConfig'
  ],
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    batchSetting: { // 批量设置
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      KNG_TYPE,
      COURSE_ATTRIBUTE,
      url: '',
      showAIError: false,
      error: false
    };
  },
  computed: {
    attrConfigs() {
      return this.getAttrConfigs();
    },
    config() {
      return this.getConfig();
    },
    multiConfig() {
      return this.getMultiConfig();
    },
    faceConfig() {
      return this.getFaceConfig();
    },
    isEdit() {
      return this.getIsEdit();
    },
    baseAttrs() {
      return this.info.customAttributes.filter(
        item => item.attrKey === COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE
      );
    },
    relatedAttrs() {
      return this.info.customAttributes.filter(
        item => item.attrKey === COURSE_ATTRIBUTE.CUSTOM_RELATED
      );
    },
    pointImageUrl() {
      return `${this.$staticBaseUrl}ufd/55a3e0/kng/pc/img/${this.info.type === KNG_TYPE.AUDIO ? 'points_audio.png' : 'points_video.png'}`;
    },
    useInBuyCourse() {
      return this.getUseInBuyCourse();
    },
    canEditCredits() {
      return this.getPermissionConfig().editCredits;
    },
    isHideAISubtitles() {
      const aISubtitles = checkTimeOutFnc('AI_subtitles');
      return aISubtitles >= 2 && aISubtitles <= 4;
    }
  },
  created() {
    // 设置默认值
    if (this.info.enableBbs === undefined && this.getItemShow('bbs')) {
      this.$set(this.info, 'enableBbs', 1);
    }
    if (this.info.enableNote === undefined && this.getItemShow('note')) {
      this.$set(this.info, 'enableNote', 1);
    }
    this.$root.$on('ai_fail', this.handleAiError);
  },
  beforeDestroy() {
    this.$root.$off('ai_fail', this.handleAiError);
  },
  methods: {
    validate() {
      this.error = false;
      return new Promise((resolve, reject) => {
        this.$refs.form &&
          this.$refs.form.validate(async valid => {
            // 表单校验
            if (valid) {
              try {
                // 附件校验
                this.$refs.attachmentForm && await this.$refs.attachmentForm.validate();
                // 人脸识别校验
                this.$refs.faceForm && await this.$refs.faceForm.validate();
                if ([KNG_TYPE.AUDIO, KNG_TYPE.VIDEO, KNG_TYPE.DOC].includes(this.info.type) && !this.info.fileId) {
                  this.$message.error(this.$t('pc_kng_upload_msg_it_error'/** 网络似乎开小差了，请重新上传试试。 */));
                  reject(new Error('fileId fail'));
                  this.validateFail();
                  return;
                }
                resolve();
              } catch (error) {
                reject(error);
                this.validateFail();
              }
            } else {
              reject(new Error('fail'));
              this.validateFail();
            }
          });
      });
    },
    validateFail() {
      this.error = true;
      setTimeout(() => {
        const doms = document.getElementsByClassName('yxtbiz-kng-operator__form--error').length ? document.getElementsByClassName('yxtbiz-kng-operator__form--error')[0].getElementsByClassName('yxt-form-item__error') : [];
        if (doms.length) {
          const dom = doms[0];
          dom.scrollIntoView({ block: 'center' });
        }
      }, 300);
    },
    handleAiError() {
      this.showAIError = true;
      this.$refs.form.validateField('subtitlesFlag');
      this.validateFail();
    },
    changeOriginal(val) {
      const attr = this.getAttrConfig(COURSE_ATTRIBUTE.AUTHOR);
      if (val && !this.info.author && attr.selectRange === 0 && localStorage.fullname) {
        this.$set(this.info, 'author', localStorage.fullname);
      }
    },
    // 获取自定义属性配置
    getAttrConfig(key) {
      return this.attrConfigs.find(item => item.attrKey === key) || {disabled: 1};
    },

    // 获取表单验证规则
    // config自己添加的属性配置（8，14类型的）
    getItemRules(key, attr = {}) {
      const config = this.attrConfigs.find(item => item.id === attr.attrId) || {};
      if (key === 'link') {
        return [{
          required: true,
          message: this.$t('pc_biz_lbl_courselinkcannotempty'/** 课件链接不能为空！ */),
          trigger: ['blur', 'change']
        },
        {
          trigger: ['blur', 'change'],
          validator: (rule, value, callback) => {
            if (!/^(https|http):\/\//.test(value)) {
              callback(new Error(this.$t('pc_kng_courseware_tip_correct_address'/** 请输入正确的网址 */)));
            }
            callback();
          }
        }];
      } else if (key === 'browser') {
        return {
          trigger: ['change'],
          validator: (rule, value, callback) => {
            const { permissionType, browsePermissions } = this.info;
            if (
              permissionType === 1 &&
              (!browsePermissions || browsePermissions.length === 0)
            ) {
              callback(new Error(this.$t('pc_biz_lbl_independentauthcantempty'/** 单独设置浏览权限不能为空 */)));
            }
            callback();
          }
        };
      } else if (key === 'download') {
        return {
          trigger: ['change'],
          validator: (rule, value, callback) => {
            const { downEnabled, allowDown, downloadPermissions } = this.info;
            if (
              downEnabled &&
              allowDown === 1 &&
              (!downloadPermissions || downloadPermissions.length === 0)
            ) {
              callback(new Error(this.$t('pc_biz_lbl_independentdownauthcantempty'/** 单独设置下载权限不能为空 */)));
            }
            callback();
          }
        };
      } else if (key === 'appCache') {
        return {
          trigger: ['change'],
          validator: (rule, value, callback) => {
            const { appDownEnabled, allowAppDown, appDownloadPermissions } =
              this.info;
            if (
              appDownEnabled &&
              allowAppDown === 1 &&
              (!appDownloadPermissions || appDownloadPermissions.length === 0)
            ) {
              callback(new Error(this.$t('pc_biz_lbl_independentcacheauthcantempty'/** 单独设置app缓存权限不能为空 */)));
            }
            callback();
          }
        };
      } else if (key === 'visitor') {
        return {
          trigger: ['change'],
          validator: (rule, value, callback) => {
            const { encryptEnabled, encryptPwd, visitorEnabled } =
              this.info.visitorConfDTO || {};
            if (visitorEnabled && encryptEnabled) {
              if (!encryptPwd) callback(new Error(this.$t('pc_biz_lbl_pwdcantempty'/** 密码不能为空 */)));
              else if (encryptPwd.length !== 6) callback(new Error(this.$t('pc_kng_upload_label_pwd_tip_visitor'/** 请设置6位数密码 */)));
            }
            callback();
          }
        };
      } else if (key === 'AI') {
        return {
          trigger: ['change'],
          validator: (rule, value, callback) => {
            if (this.showAIError) {
              this.showAIError = false;
              callback(new Error(this.$t('pc_kng_lbl_ai_account_balance2'/** AI字幕账户余额不足，请及时充值 */)));
            }
            callback();
          }
        };
      } else if (key === 'indexPath') {
        return {
          required: true,
          trigger: ['blur', 'change'],
          message: this.$t('pc_biz_lbl_itemcantempty', [this.$t('pc_kng_kngcourse_lbl_setindex')])
        };
      }
      // 自定义的属性
      if ([COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE, COURSE_ATTRIBUTE.CUSTOM_RELATED].includes(key)) {
        return [
          {
            required: !!config.required,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!!config.required && [undefined, '', null].includes(attr.value)) {
                callback(new Error(this.$t('pc_biz_lbl_itemcantempty', [config.attrName])));
              } else {
                callback();
              }
            }
          },
          {
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) =>
              this._validateCustom(callback, attr)
          }
        ];
      }
      const attrConfig = this.getAttrConfig(key);
      if (key === COURSE_ATTRIBUTE.DESCRIBE) {
        return {
          required: !!attrConfig.required,
          validator: (rule, value, callback) => {
            if (rule.required && (!value || value.length === 0)) {
              callback(new Error(this.$t('pc_biz_lbl_itemcantempty', [attrConfig.attrName])));
            } else if (value && value.length > 30000) {
              callback(new Error(this.$t('pc_biz_lbl_desc_err'/** 简介富文本格式异常 */)));
            } else {
              callback();
            }
          },
          trigger: ['change', 'blur']
        };
      } else if ([COURSE_ATTRIBUTE.CONTENT_TAG, COURSE_ATTRIBUTE.SKILL_TAG].includes(key)) {
        return {
          required: !!attrConfig.required,
          validator: (rule, value, callback) => {
            if (rule.required && (!value || value.length === 0)) {
              callback(new Error(this.$t('pc_biz_lbl_itemcantempty', [attrConfig.attrName])));
            } else if (value && value.length > 20) {
              callback(new Error(this.$t('pc_kng_kngcourse_msg_msg13'/** 标签最多只能添加{count}个 */, { count: 20 })));
            } else {
              callback();
            }
          },
          trigger: ['change', 'blur']
        };
      }
      if (!attrConfig.required) return undefined;
      switch (key) {
        case COURSE_ATTRIBUTE.NAME:
        case COURSE_ATTRIBUTE.TIME:
        case COURSE_ATTRIBUTE.SCORE:
        case COURSE_ATTRIBUTE.PRICE:
        case COURSE_ATTRIBUTE.CONTRIBUTOR:
        case COURSE_ATTRIBUTE.AUTHOR:
        case COURSE_ATTRIBUTE.LECTURER:
        case COURSE_ATTRIBUTE.ASSISTANT_LECTURER:
        case COURSE_ATTRIBUTE.UNIQUE_CODE:
          return {
            required: !!attrConfig.required,
            message: this.$t('pc_biz_lbl_itemcantempty', [attrConfig.attrName]),
            validator: (...params) => this._validateCommon(key, ...params),
            trigger: ['blur', 'change']
          };
        case COURSE_ATTRIBUTE.CUSTOM_CODE:
          return {
            required: !!attrConfig.required,
            validator: (rule, value, callback) => { callback(); },
            trigger: ['blur', 'change']
          };
        case COURSE_ATTRIBUTE.CATAlOG:
          return {
            required: !!attrConfig.required,
            message: this.$t('pc_biz_lbl_itemcantempty', [attrConfig.attrName]),
            validator: (...params) => this._validateCommon(key, ...params),
            trigger: ['change']
          };
        case COURSE_ATTRIBUTE.VALID_DATE:
          return [
            {
              required: !!attrConfig.required,
              message: this.$t('pc_biz_lbl_itemcantempty', [attrConfig.attrName]),
              validator: (...params) => this._validateCommon(key, ...params),
              trigger: ['blur', 'change']
            },
            {
              trigger: ['blur', 'change'],
              validator: (rule, value, callback) => {
                const {expireDay, expireHours} = this.info;
                if (expireDay === undefined || expireHours === undefined) {
                  callback(new Error(this.$t('pc_biz_kng_lbl_noticetime')));
                } else {
                  callback();
                }
              }
            }
          ];
      }
      return undefined;
    },
    _validateCommon(key, rule, value, callback) {
      if (!this.getItemDisabled(key) && [null, '', undefined].includes(value)) {
        callback(new Error(rule.message));
      } else {
        callback();
      }
    },
    _validateCustom(callback, attr) {
      const config = this.attrConfigs.find(item => item.id === attr.attrId) || {};
      if (attr.value && attr.attrKey === COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE) {
        const { attrType, rangeMin, rangeMax } = config;
        if (attrType === '2') {
          // 日期
          if (
            (rangeMin &&
              attr.value &&
              new Date(attr.value).getTime() < new Date(rangeMin).getTime()) ||
            (rangeMax &&
              attr.value &&
              new Date(attr.value).getTime() > new Date(rangeMax).getTime())
          ) {
            callback(
              new Error(this.$t('pc_biz_lbl_daterange', [rangeMin, rangeMax]))
            );
          }
        } else if (attrType === '1') {
          // 字符
          if (
            (rangeMin && attr.value && attr.value.length < ~~rangeMin) ||
            (rangeMax && attr.value && attr.value.length > ~~rangeMax)
          ) {
            callback(
              new Error(this.$t('pc_biz_lbl_lengthrange', [rangeMin, rangeMax]))
            );
          }
        } else if (attrType === '0') {
          // 数字
          if (
            (rangeMin &&
              (attr.value || attr.value === 0) &&
              attr.value < ~~rangeMin) ||
            (rangeMax &&
              (attr.value || attr.value === 0) &&
              attr.value > ~~rangeMax)
          ) {
            callback(
              new Error(this.$t('pc_biz_lbl_datarange', [rangeMin, rangeMax]))
            );
          }
        }
      }
      callback();
    },

    // 显示状态
    getItemShow(key) {
      const attrConfig = this.getAttrConfig(key);
      const isEdit = this.isEdit;
      const {
        type,
        fileType,
        uniqueCode,
        shareFlag,
        weikeType,
        specialMode,
        serverGroupId,
        distributeSourceType,
        newFileId,
        allowDown
      } = this.info;
      const {
        isBossCanDownload,
        isBossCanDownloadVideo,
        isBossCanDownloadAudio,
        isBossCanDownloadDoc,
        skillTagOpened,
        definitionOpened,
        sizeLimitOpened,
        forbidDrag
      } = this.config;
      switch (key) {
        case COURSE_ATTRIBUTE.NAME:
          return !attrConfig.disabled && !this.batchSetting;
        case COURSE_ATTRIBUTE.CATAlOG:
        case COURSE_ATTRIBUTE.PRICE:
        case COURSE_ATTRIBUTE.CONTRIBUTOR:
        case COURSE_ATTRIBUTE.AUTHOR:
        case COURSE_ATTRIBUTE.LECTURER:
        case COURSE_ATTRIBUTE.ASSISTANT_LECTURER:
        case COURSE_ATTRIBUTE.VALID_DATE:
        case COURSE_ATTRIBUTE.ATTACHMENT:
          return !attrConfig.disabled;
        case COURSE_ATTRIBUTE.CUSTOM_CODE:
          return !attrConfig.disabled && !this.useInBuyCourse;
        case COURSE_ATTRIBUTE.TIME:
        case COURSE_ATTRIBUTE.SCORE:
          // 创建时候SCORM,HTML,WEIKE 展示
          // 编辑时候zip和外链不展示，其余都显示
          return (
            !attrConfig.disabled &&
            ((!isEdit && [KNG_TYPE.SCORM, KNG_TYPE.HTML, KNG_TYPE.WEIKE].includes(type)) ||
              (isEdit && ![KNG_TYPE.ZIP, KNG_TYPE.NEWLINK].includes(type))) && !this.batchSetting
          );
        case COURSE_ATTRIBUTE.UNIQUE_CODE:
          return this.isEdit && !attrConfig.disabled && uniqueCode;
        case COURSE_ATTRIBUTE.CONTENT_TAG:
        case COURSE_ATTRIBUTE.DESCRIBE:
          return (!attrConfig.disabled || shareFlag === 2) && !this.useInBuyCourse;
        case COURSE_ATTRIBUTE.SKILL_TAG:
          return (
            (!attrConfig.disabled || shareFlag === 2) &&
            ([2, 3, 4].includes(checkTimeOutFnc('online_course_skill_label_choose')) || [2, 3, 4].includes(checkTimeOutFnc('talentmanagement'))) &&
            skillTagOpened && !this.useInBuyCourse
          );
        case 'link':
          return type === KNG_TYPE.NEWLINK;
        case 'coverUrl':
          return shareFlag !== 2;
        case 'completeStandard':
          return [
            KNG_TYPE.VIDEO,
            KNG_TYPE.AUDIO,
            KNG_TYPE.SCORM,
            KNG_TYPE.WEIKE,
            KNG_TYPE.NEWLINK
          ].includes(type);
        case 'fontSize':
          return (
            definitionOpened &&
            (type === KNG_TYPE.DOC &&
            fileType !== KNG_FILE_TYPE.IMAGE &&
            !serverGroupId || this.batchSetting)
          );
        case 'fontSizeLimit': // 是否展示极限字体设置
          return (
            sizeLimitOpened &&
            (type === KNG_TYPE.DOC &&
            fileType !== KNG_FILE_TYPE.IMAGE &&
            !serverGroupId || this.batchSetting)
          );
        case 'displayMode':
          return (
            type === KNG_TYPE.DOC &&
            fileType !== KNG_FILE_TYPE.IMAGE &&
            !serverGroupId || this.batchSetting
          );
        case 'dataType':
          return checkTimeOutFnc('kng_tag_display') === 2;
        case 'supplier':
          return checkTimeOutFnc('sdcs_supplier') === 2;
        case 'appEnabled':
          return [KNG_TYPE.SCORM, KNG_TYPE.HTML, KNG_TYPE.NEWLINK].includes(type);
        case 'download':
          return (
            !distributeSourceType && isBossCanDownload &&
            ((type === KNG_TYPE.VIDEO && isBossCanDownloadVideo) ||
              (type === KNG_TYPE.AUDIO && isBossCanDownloadAudio) ||
              (type === KNG_TYPE.DOC && isBossCanDownloadDoc) ||
              this.batchSetting)
          );
        case 'download_source':
          return allowDown && this.getItemShow('download');
        case 'appCache':
          return (
            !distributeSourceType && (this.batchSetting || [KNG_TYPE.VIDEO, KNG_TYPE.AUDIO, KNG_TYPE.DOC].includes(type)) &&
            ![0, 1, 3, 5].includes(
              checkTimeOutFnc('App_cache_permission_hidden')
            )
          );
        case 'visitor':
          return (
            checkTimeOutFnc('Tourists_learn') === 2 &&
            (type !== KNG_TYPE.ZIP && distributeSourceType === 0 || this.batchSetting)
          );
        case 'autoUpgrade':
          return type === KNG_TYPE.WEIKE && weikeType === 2;
        case 'bbs':
          const val = checkTimeOutFnc('discussion_enable');
          return val >= 2 && val <= 4;
        case 'note':
          return checkTimeOutFnc('learning_note') === 2;
        case 'watermark':
          return (
            isBossCanDownload &&
            (type === KNG_TYPE.DOC && isBossCanDownloadDoc ||
            this.batchSetting)
          );
        case 'multiShow':
          return (
            this.multiConfig.enabled &&
            (this.batchSetting || [KNG_TYPE.COURSE, KNG_TYPE.VIDEO, KNG_TYPE.AUDIO].includes(type) ||
              (type === KNG_TYPE.WEIKE && weikeType === 2 && distributeSourceType === 0))
          );
        case 'drag':
          return (
            !forbidDrag &&
            (this.batchSetting || [KNG_TYPE.COURSE, KNG_TYPE.VIDEO, KNG_TYPE.AUDIO].includes(type))
          );
        case 'face':
          return (
            checkTimeOutFnc('Face_recognition_configuration_in_class') === 2 &&
            !specialMode &&
            ![KNG_TYPE.ZIP, KNG_TYPE.NEWLINK, KNG_TYPE.COURSE].includes(type) &&
            (type !== KNG_TYPE.WEIKE || weikeType !== 1) &&
            this.faceConfig.enabled
          );
        case 'point':
          return isEdit && (type === KNG_TYPE.AUDIO || type === KNG_TYPE.VIDEO) && distributeSourceType === 0 && !specialMode && !newFileId && shareFlag !== 2;
        case 'AI':
          return !this.isHideAISubtitles && (this.batchSetting || type === KNG_TYPE.AUDIO || type === KNG_TYPE.VIDEO) && !serverGroupId && !distributeSourceType;
      }
      return true;
    },

    // disabled 状态
    getItemDisabled(key) {
      const isEdit = this.isEdit;
      const { type, weikeType, shareFlag, platform, status, subtitlesStatus, serverGroupId, distributeSourceType } = this.info;
      if (shareFlag === 2 && ![COURSE_ATTRIBUTE.CATAlOG, COURSE_ATTRIBUTE.SCORE, 'visiable', 'browser'].includes(key)) {
        // 集团版统一拦截
        return true;
      }
      switch (key) {

        case COURSE_ATTRIBUTE.NAME:
          return this.useInBuyCourse;
        case COURSE_ATTRIBUTE.CATAlOG:
          return this.useInBuyCourse || (type !== KNG_TYPE.COURSE && !!distributeSourceType);
        case COURSE_ATTRIBUTE.VALID_DATE:
          return !!distributeSourceType;
        case COURSE_ATTRIBUTE.TIME:
          // 课程：不能修改
          // 创建：SCORM,HTML,老微课可修改
          // 编辑：文档,SCORM,HTML,老微课 可修改
          return type === KNG_TYPE.COURSE || !(
            [KNG_TYPE.SCORM, KNG_TYPE.HTML].includes(type) ||
            (type === KNG_TYPE.WEIKE && weikeType === 1) ||
            (isEdit && type === KNG_TYPE.DOC)
          );
        case COURSE_ATTRIBUTE.SCORE:
          // 课程：不能修改
          return type === KNG_TYPE.COURSE;
        case COURSE_ATTRIBUTE.CONTRIBUTOR:
        case COURSE_ATTRIBUTE.AUTHOR:
        case COURSE_ATTRIBUTE.LECTURER:
        case COURSE_ATTRIBUTE.ASSISTANT_LECTURER:
        case COURSE_ATTRIBUTE.CUSTOM_RELATED:
          return this.useInBuyCourse;
        case COURSE_ATTRIBUTE.CONTENT_TAG:
        case COURSE_ATTRIBUTE.ATTACHMENT:
          return shareFlag === 2;
        case 'visiable':
          return this.useInBuyCourse;
        case 'browser':
          return this.useInBuyCourse;
        case 'download':
          return shareFlag === 2;
        case 'download_source':
          return shareFlag === 2;
        case 'appCache':
          return checkTimeOutFnc('App_cache_permission_hidden') === 6 || serverGroupId || shareFlag === 2;
        case 'displayMode':
          return platform === 1;
        case 'point':
          return status === 0 || status === 1;
        case 'completeStandard':
          return isEdit && ([KNG_TYPE.NEWLINK, KNG_TYPE.SCORM].includes(type) || (type === KNG_TYPE.WEIKE && weikeType === 2));
        case 'AI':
          // subtitlesStatus	AI字幕识别状态 0：默认 1：识别中 2：识别成功 3：识别失败
          return !subtitlesStatus && !this.config.canUseAI;
      }
      return false;
    },
    view(type) {
      const imgUrls = {
        0: isZhOrHa ? 'ufd/407a24/kng/pc/img/project-materials.png' : 'ufd/55a3e0/kng/pc/img/project-materials_en.png',
        1: isZhOrHa ? 'ufd/407a24/kng/pc/img/mode-mark.png' : 'ufd/d8a55a/kng/pc/img/mode-mark_en.png'
      };
      this.url = this.$staticBaseUrl + imgUrls[type];
      this.$nextTick(() => {
        this.$refs.viewer && this.$refs.viewer.view(0);
      });
    },
    didSelectSupplier(obj) {
      this.$set(this.info, 'supplierId', obj.supplierCreditCode);
      this.$set(this.info, 'supplierName', obj.supplierName);
    },
    changeStudyHours() {
      this.$set(this.info, 'studyScore', getScoreWithConfig(this.info, this.getScoreConfig()));
    }
  }
};
</script>
